import { IntercomProvider } from "react-use-intercom"
import { type ReactNode } from "react"
import { useFlags } from "~/features/feature-flags"

interface IntercomProviderProps {
  children: ReactNode
}

export const IntercomProviderWrapper = ({ children }: IntercomProviderProps) => {
  const { maintenanceMode: maintenanceModeFlag } = useFlags()

  const INTERCOM_APP_ID = "u3tkl3yd"

  if (!INTERCOM_APP_ID) {
    console.warn("Intercom App ID is not configured. Intercom will not be initialized.")
    return <>{children}</>
  }

  return (
    <IntercomProvider
      appId={INTERCOM_APP_ID}
      apiBase="https://api-iam.eu.intercom.io"
      autoBoot={maintenanceModeFlag}
      autoBootProps={{
        hideDefaultLauncher: false,
      }}
    >
      {children}
    </IntercomProvider>
  )
}
